import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ART_FUND_DETAILS } from './../../utils/config';
import SelectedFundList from './SelectedFundList';
import SearchFund from './SearchFund';
import SelectSunsuperAsDefault from './SelectSunsuperAsDefault';
import {
  setARTSelected,
  setSelectedFunds
} from '../../store/actions/globalActions';
import { getDateInYYYYMMDDFormat, isActive } from './../../utils/date';

const SelectContainer = props => {
  const dispatch = useDispatch();
  const { isBureau } = useSelector(state => state.participant.data);
  const { isARTSelected, funds } = useSelector(state => state.global.data);

  const { onSelectUpdate, fundsToDisplay } = props;

  const toggleFundFromSelected = toggleFund => {
    const currentFunds = Array.isArray(funds) ? funds : [];
    const nextFunds = [...currentFunds];

    const selectedUSI = nextFunds.map(selectedFund => selectedFund.usi);
    const index = selectedUSI.indexOf(toggleFund.usi);

    if (index > -1) {
      nextFunds[index] = {
        ...nextFunds[index],
        endDate: nextFunds[index].endDate ? null : getDateInYYYYMMDDFormat() // bring back the fund if it already has endDate
      };
    } else {
      // new added fund, set startDate to today
      nextFunds.push({
        ...toggleFund,
        startDate: getDateInYYYYMMDDFormat()
      });
    }

    const hasARTSelected =
      nextFunds
        .filter(fund => !fund.endDate || isActive(fund.endDate))
        .map(selectedFund => selectedFund.usi)
        .indexOf(ART_FUND_DETAILS.uniqueSuperannuationIdentifier) > -1;

    dispatch(setSelectedFunds(nextFunds));
    dispatch(setARTSelected(hasARTSelected));

    if (onSelectUpdate) {
      onSelectUpdate(nextFunds);
    }
  };

  const handleRemove = usi => {
    const fund = fundsToDisplay.filter(fund => fund.usi === usi)[0];
    toggleFundFromSelected(fund);
  };

  return (
    <section className="Section SelectContainer">
      {fundsToDisplay &&
        fundsToDisplay.length > 0 && (
          <div className="row">
            <div className="col-sm-7">
              <SelectedFundList
                selected={fundsToDisplay}
                onRemove={handleRemove}
              />
            </div>

            <div className="col-sm-5">
              <div className="ReverseCallout">
                <h3>
                  {isARTSelected
                    ? isBureau
                      ? 'Make sure your employer client’s details are registered with Australian Retirement Trust.'
                      : 'We’ll create an Australian Retirement Trust Employer account for you if you don’t already have one.'
                    : 'You can add more than one default fund'}
                </h3>
              </div>
            </div>
          </div>
        )}

      {fundsToDisplay &&
        fundsToDisplay.length === 0 && (
          <React.Fragment>
            <h2>
              {isBureau
                ? 'Would you like to make Australian Retirement Trust the default fund for this employer client?'
                : 'Would you like to make Australian Retirement Trust your default fund?'}
            </h2>
            <SelectSunsuperAsDefault onFundToggle={toggleFundFromSelected} />
            <div
              style={{
                margin: '3rem 0',
                textAlign: 'center',
                fontWeight: '700'
              }}
            >
              {' '}
              - Or -{' '}
            </div>
            <h2>No, I'd prefer to search for a different default fund.</h2>
          </React.Fragment>
        )}

      <SearchFund
        selected={fundsToDisplay}
        onFundToggle={toggleFundFromSelected}
      />
    </section>
  );
};

export default SelectContainer;
